Object.defineProperty(exports, '__esModule', { value: true });

function preventDefault(e) {
    e.preventDefault();
}
var dom = {
    preventDefault: preventDefault,
};

exports.dom = dom;
